import { useRouter } from 'next/router';
import DynamicIcon from "./dynamic-icon";
import Image from "next/image";
import { prefix } from '../../lib/auth';
import Tooltips from './tooltip';
import ComingSoonText from './coming-soon-text';
import { getCachedBusiness } from '../../lib/utils';

// One app in the app switcher. With `href` it is a link to that address
// (Newtmail's tile); otherwise a click opens <peg>.workpeg.com for the
// cached business. `logos` is a { light, dark } pair of image URLs, shown
// by the colour scheme, for an app whose mark is not in /images.
const AppItem = ({ children, subtitle, icon, active, additionalclasses, peg, image, logos, href, tag }) => {
    const cacheBusiness = getCachedBusiness();

    const router = useRouter();
    const className = `flex w-full py-[11.29px] px-[9.86px] items-center custom-text-grey-800 ${tag === 'Coming soon' ? 'cursor-not-allowed' : 'cursor-pointer'} content-center justify-between hover:custom-bg-grey-50 group rounded-lg dropdown-option ${active ? 'dark:bg-grey-600 bg-white-50' : ''} ${additionalclasses}`;
    const content = (
        <>
            <div className="grid grid-flow-col items-center justify-start gap-[12px]">
                {icon && <DynamicIcon name={icon} size={24} />}
                {image &&
                    <>
                        <Image src={`/images/${image}.svg`} width={24} height={24} alt={children} className="block dark:hidden" />
                        <Image src={`/images/dark-${image}.svg`} width={24} height={24} alt={children} className="dark:block hidden" />
                    </>
                }
                {logos &&
                    <>
                        <Image src={logos.light} width={24} height={24} alt="" className="block dark:hidden" />
                        <Image src={logos.dark} width={24} height={24} alt="" className="dark:block hidden" />
                    </>
                }
                <div className="grid grid-flow-col gap-3 items-center">
                    <div className="grid grid-flow-col items-center">
                        <div className="grid">
                            <span className="poppins-regular text-[14px] custom-text-grey-900  leading-[15px] whitespace-nowrap flex items-center gap-[8px]">
                                {children}
                                {tag && <ComingSoonText>{tag}</ComingSoonText>}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {active && (<DynamicIcon name='check' size={18} color='' />)}
        </>
    );
    return (
        <Tooltips position={tag === 'Coming soon' ? 'bottom' : ''} content={tag}>
            {href ? (
                <a href={href} data-app-item={peg} className={className}>{content}</a>
            ) : (
                <div onClick={() => { tag !== 'Coming soon' ? router.push(`http://${prefix()}${peg}.workpeg.com/${cacheBusiness}`) : null }} className={className}>
                    {content}
                </div>
            )}
        </Tooltips>
    );
};

export default AppItem;
